import styled from "@emotion/styled";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import projectColors from "themes/projectColors";

const StandaloneDropdownArrow = styled(KeyboardArrowDownIcon)(() => ({
  color: projectColors.functional.black,
  height: "24px",
  width: "24px",
}));

export default StandaloneDropdownArrow;
